import { render, staticRenderFns } from "./DeleteRowTooltip.vue?vue&type=template&id=d56e578a&scoped=true&"
import script from "./DeleteRowTooltip.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DeleteRowTooltip.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DeleteRowTooltip.vue?vue&type=style&index=0&id=d56e578a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56e578a",
  null
  
)

export default component.exports